import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import { updateFavourites } from '../store/reducers/favourite';
import useTopicFunctions from '../hooks/useTopicFunctions';

const AddFavouriteModal = (props) => {
  const dispatch = useDispatch();
  const {
    isCurrentFave,
    favourite,
    section,
    toc,
    setFavourite,
    shouldLoad,
    setShouldLoad,
    openModal,
    closeAddFavorite,
    setAddFavouriteClass,
  } = props;
  const [showAdd, setShowAdd] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showDone, setShowDone] = useState(false);
  const [favouriteInputClass, setFavouriteInputClass] = useState('');

  const { addNewFav } = useTopicFunctions();

  useEffect(() => {
    if (shouldLoad) {
      if (isCurrentFave) {
        setShowView(true);
        setShowDone(true);
        setShowAdd(false);
        setShowCancel(false);
        setFavourite('This is already in your favourites.')
      } else {
        if(props.favourite.length > 0)
          setShowAdd(true);
        else 
          setShowAdd(false);
        
        setShowCancel(true);
        setShowView(false);
        setShowDone(false);
      }
    }
  }, [shouldLoad, isCurrentFave]);

  const addFaveHandler = () => {
    addNewFav(favourite, toc, section);
    dispatch(updateFavourites());
    setFavourite('A new favourite has been added.');
    setShowAdd(false);
    setShowView(true);
    setShowCancel(false);
    setShowDone(true);
    setFavouriteInputClass('faveFocus');
    setAddFavouriteClass('savedTopic');
  };

  const doneFaveHandler = () => {
    closeAddFavorite();
    setShowView(false);
    setShowAdd(true);
    setShowCancel(true);
    setShouldLoad(false);
  }

  const cancelFaveHandler = () => {
    closeAddFavorite();
    setShouldLoad(false);
  }

  const viewFaveHandler = () => {
    closeAddFavorite();
    setShowView(false);
    setShowAdd(true);
    setShowCancel(true);
    setShouldLoad(false);
    openModal(true);
  }

  return (
    <div className="popover fade bottom in" role="tooltip" id="popover776982">
      <div className="arrow" style={{ 'left': '38%' }}></div>
      <h3 className="popover-title">Add to favourites</h3>
      <div className="popover-content">
        <div className="form-group">
          <label className="sr-only" htmlFor="SelectID"></label>
          <div className="col-md-12 col-lg-12">
            <input
              type="text"
              className={`form-control grayBorder marginBottom5px ${favouriteInputClass}`}
              id="favhiddenIDName"
              name="favourites.favouritename"
              readOnly={true}
              value={favourite}
            />
          </div>
        </div>
        <div className="form-group">
          <div style={{ display: 'flex', justifyContent: 'center' }} className="col-xs-12">
            {showAdd && <button style={{ 'minWidth': '87px' }} type="button" className="btn btn-info borderNone" id="add" data-toggle="popover" onClick={() => addFaveHandler()}> Add Now</button>}
            {showView && <button style={{ 'minWidth': '87px'}} type="button" className="btn btn-info borderNone" id="viewall" data-toggle="popover" onClick={() => viewFaveHandler(true)}> View All </button>}
            {showCancel && <button style={{ 'minWidth': '71px' }} type="button" className="btn btn-default borderNone" id="favcancel" onClick={() => cancelFaveHandler()}>Cancel</button>}
            {showDone && <button style={{ 'minWidth': '71px' }} type="button" className="btn btn-default borderNone" id="favdone" onClick={() => doneFaveHandler()} >Done</button>}
          </div>
        </div>
      </div>
    </div>
  )
};

AddFavouriteModal.propTypes = {
  isCurrentFave: PropTypes.bool.isRequired,
  favourite: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  toc: PropTypes.string.isRequired,
  setFavourite: PropTypes.func.isRequired,
  shouldLoad: PropTypes.bool.isRequired,
  setShouldLoad: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeAddFavorite: PropTypes.func.isRequired,
  setAddFavouriteClass: PropTypes.func.isRequired,
};

export default AddFavouriteModal;
